import { render, staticRenderFns } from "./ContributorFullPage.vue?vue&type=template&id=9bd06152&"
import script from "./ContributorFullPage.vue?vue&type=script&lang=js&"
export * from "./ContributorFullPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports